export default __webpack_public_path__ + "static/media/urgently-logo-orange.18805984.svg";